import PropTypes from 'prop-types';
import styled from 'styled-components';
import { numericFormatter, loanUtil } from '@figure/frontlib-util';
import { Color } from '@figure/frontlib-gui';
import { Typography } from 'shared/components';
import { OfferSelectCalculations } from 'shared/utils';

const OfferDetailsTitle = styled(Typography.BodyBold)`
  color: ${Color.WHITE};
  border-bottom: 1px solid ${Color.PURPLE_DUSK};
  padding-bottom: 8px;
  margin-bottom: 16px;
  margin-top: 50px;
`;

const OfferHeader = styled(Typography.H4)`
  color: ${Color.WHITE};
  line-height: inherit;
`;

const SmallBodyWhite = styled(Typography.SmallBody)`
  color: ${Color.WHITE};
`;

const OfferType = styled(SmallBodyWhite)`
  margin-bottom: 10px;
`;

const SidebarOfferDetails = ({ selectedOffer, hideSelectedOffer }) => {
  const isOfferSelected = !!selectedOffer?.amount;

  if (!isOfferSelected || hideSelectedOffer) return null;

  const totalLoanAmount = loanUtil.getTotalAmountFromDraw(selectedOffer.amount, selectedOffer.originationFeePercentage);
  const monthlyPayment = OfferSelectCalculations.getMonthlyPayment(totalLoanAmount, selectedOffer.rate, selectedOffer.term);
  const displayLoanAmount = numericFormatter.formatMoney(selectedOffer.amount);
  const displayMonthlyPayment = numericFormatter.formatMoney(monthlyPayment);
  const displayTerm = `${selectedOffer.term} year`;
  const displayAPR = numericFormatter.formatPercentage(selectedOffer.aprRate, 100, 2);

  return (
    <>
      <OfferDetailsTitle>Your Offer Details</OfferDetailsTitle>
      <OfferHeader>{displayAPR}</OfferHeader>
      <OfferType>APR</OfferType>
      <OfferHeader>{displayLoanAmount}</OfferHeader>
      <OfferType>Loan amount</OfferType>
      <OfferHeader>{displayMonthlyPayment}</OfferHeader>
      <OfferType>Monthly payment</OfferType>
      <OfferHeader>{displayTerm}</OfferHeader>
      <OfferType>Fixed term</OfferType>
    </>
  );
};

SidebarOfferDetails.propTypes = {
  selectedOffer: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    rate: PropTypes.number.isRequired,
    term: PropTypes.number.isRequired,
    aprRate: PropTypes.number.isRequired,
    originationFeePercentage: PropTypes.number.isRequired,
  }),
  hideSelectedOffer: PropTypes.bool.isRequired,
};

SidebarOfferDetails.defaultProps = {
  selectedOffer: null,
};

export default SidebarOfferDetails;
